import { render } from "./UiSwitch.vue?vue&type=template&id=64253bc3&ts=true"
import script from "./UiSwitch.vue?vue&type=script&lang=ts"
export * from "./UiSwitch.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__